// Gift with Purchase: Update progress bar
function updateGiftWithPurchase(cart) {
  const giftContainer = document.querySelector('.gift-with-purchase-container');
  const goalAmount = parseFloat(giftContainer.dataset.goalAmount); // Read from data attribute
  const currentAmount = cart.total_price / 100; // Convert cents to dollars
  const progressPercentage = Math.min((currentAmount / goalAmount) * 100, 100);
  const awayAmount = goalAmount - currentAmount;
  giftContainer.setAttribute('data-progress-width' , `${progressPercentage}%`);
  giftContainer.setAttribute('data-away-amount' , awayAmount)


  // Update progress bar and text
  const progressBar = document.getElementById('gift-progress');

  if (progressBar) {
    progressBar.style.height = progressPercentage + '%';
  }
}

// Fetch cart data and update the progress bar
function fetchCartData() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      updateGiftWithPurchase(data);
    })
    .catch(error => console.error('Error fetching cart data:', error));
}

// Intercept cart AJAX calls using both fetch and XMLHttpRequest
(function() {
  // Intercept fetch API
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    if (args[0].includes('/cart') && response.ok) {
      response.clone().json().then(data => {
        fetchCartData();
      });
    }
    return response;
  };

  // Intercept XMLHttpRequest API
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
    this.addEventListener('load', function() {
      if (url.includes('/cart') && this.status >= 200 && this.status < 300) {
        fetchCartData();
      }
    });
    originalOpen.apply(this, arguments);
  };
})();

// Initial load of the progress bar
document.addEventListener('DOMContentLoaded', fetchCartData);

class PurchaseGiftButton extends HTMLElement {
  constructor() {
      super();
      this.addEventListener('click', this.handleClick);
  }

  handleClick() {
      const popup = document.querySelector('purchase-gift-popup');
      const awayAmount = parseFloat(this.getAttribute('data-away-amount'));
      const dataProgress = this.getAttribute('data-progress-width');
     
      let message = awayAmount > 0 ? `You are $${awayAmount}  Away From Your Gift` : 'You have reached the goal amount'
      if (popup) {
          
          popup.querySelector('.gift-with-purchase-remaining-text').textContent = message;
          popup.querySelector('.gift-with-purchase-bar-progress').style.width = dataProgress;
          document.querySelector('body').classList.add("popup-added-overflow-hidden");
          popup.setAttribute('open', '');
      }
  }
}

customElements.define('purchase-gift-button', PurchaseGiftButton);

class PurchaseGiftPopup extends HTMLElement {
  constructor() {
      super();
      this.closeButton = this.querySelector('.gift-with-purchase-popup-close');
      if (this.closeButton) {
          this.closeButton.addEventListener('click', this.handleClose.bind(this));
      }
  }

  handleClose() {
      document.querySelector('body').classList.remove("popup-added-overflow-hidden");
      this.removeAttribute('open');
  }
}

customElements.define('purchase-gift-popup', PurchaseGiftPopup);
